import {isMobile} from "react-device-detect";
import { CSSProperties } from 'react'

export const styles: { [key: string]: CSSProperties } = {


    header: {
        display: 'flex',
        flexDirection: 'row' as const,
        alignItems: 'center',
        justifyContent: 'flex-start',
        height: '120px',
        color: 'rgb(23, 23, 23)',
        backgroundColor: 'rgb(246, 246, 246)'
    },

    headerTitle: {
        fontSize: '2rem',
        fontWeight: 600,
        marginLeft: '30px',
        fontFamily: 'Oswald, sans-serif'
    },

    headerLogo: {
        justifySelf: 'flex-start',
        marginLeft: isMobile ? '15px' : '75px'
    },

    headerContent: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-end',
        height: '100%',
        flexGrow: 1,
        paddingRight: '75px'
    },

    headerLink: {
        marginLeft: '30px',
        textDecoration: 'none',
        fontSize: '1.1rem',
        cursor: 'pointer',
        padding: '10px 20px',
        borderRadius: '8px',
        transition: 'background-color 0.2s',
        fontWeight: 600,
    },

    selectedLink: {
        backgroundColor: 'rgb(0, 4, 255)',
        color: 'white'
    }
};
